$(document).ready(function () {
	const MOBILE_BREAKPOINT = 640;

	function resetMenuIcons() {
		$(".toggle-menu")
			.find(".menu-icon-open").removeClass("hidden").addClass("block").end()
			.find(".menu-icon-close").removeClass("block").addClass("hidden");
	}

	function setHamburgerLabel(label) {
		$(".menu-label").text(label + " ");
	}

	function normalizeLabel(text) {
		return text.trim().replace(/\s+/g, " ");
	}

	(function applyInitialLabel() {
		const $btn = $(".toggle-menu--hamburger");
		const initLabel = $btn.data("initial-label");
		if (initLabel) {
			setHamburgerLabel(normalizeLabel(initLabel));
		}
	})();

	function initMenuBehavior() {
		$(".toggle-menu").off("click mouseenter");
		$(".menu-link").off("click");
		$("nav").off("mouseleave");
		$(window).off("hashchange");

		$(".toggle-menu--hamburger").on("click", function (e) {
			e.preventDefault();
			const $btn = $(this);
			const open = !$btn.hasClass("active");
			const $panels = $("nav > div[id]");

			$(".toggle-menu").not($btn).removeClass("active");
			resetMenuIcons();
			$("nav").toggleClass("mobile-open", open);
			$("body").toggleClass("no-scroll", open);

			if (open) {
				$panels
					.removeClass("hidden absolute bottom-full")
					.addClass("block relative");
				$btn
					.addClass("active")
					.find(".menu-icon-open")
					.addClass("hidden").removeClass("block")
					.end()
					.find(".menu-icon-close")
					.removeClass("hidden").addClass("block");
			} else {
				$panels
					.addClass("hidden absolute bottom-full")
					.removeClass("block relative");
				$btn
					.removeClass("active")
					.find(".menu-icon-open")
					.removeClass("hidden").addClass("block")
					.end()
					.find(".menu-icon-close")
					.addClass("hidden").removeClass("block");
			}
		});

		if (window.innerWidth < MOBILE_BREAKPOINT) {
			$(".toggle-menu").not(".toggle-menu--hamburger").on("click", function (e) {
				e.preventDefault();
				const $this = $(this);
				const $target = $("#" + $this.data("target"));
				const open = !$this.hasClass("active");

				$("nav > div[id]").not($target).addClass("hidden");
				$(".toggle-menu").not($this).removeClass("active");
				resetMenuIcons();

				$target.toggleClass("hidden");
				$this.toggleClass("active");

				if (open) {
					$this.find(".menu-icon-open").addClass("hidden").removeClass("block");
					$this.find(".menu-icon-close").removeClass("hidden").addClass("block");
				} else {
					$this.find(".menu-icon-open").removeClass("hidden").addClass("block");
					$this.find(".menu-icon-close").addClass("hidden").removeClass("block");
				}
			});
		}

		else {
			const $toggles = $(".toggle-menu").not(".toggle-menu--hamburger");

			$toggles
				.off("mouseenter click")
				.on("mouseenter", function () {
					const $this   = $(this);
					const $target = $("#" + $this.data("target"));

					$("nav > div[id]").not($target).addClass("hidden");
					resetMenuIcons();

					$target.removeClass("hidden");
				})
				.on("click", function (e) {
					e.preventDefault();
				});

			$("nav").on("mouseleave", function () {
				$("nav > div[id]").addClass("hidden");
				resetMenuIcons();
			});
		}

		$(".menu-link").on("click", function (e) {
			const $link    = $(this);
			const hrefBase = this.href.split("#")[0];
			const hash     = this.hash;

			if (hash && hrefBase === window.location.href.split("#")[0]) {
				e.preventDefault();

				$(".menu-link").removeClass("active");
				$link.addClass("active");

				$("body").removeClass("no-scroll");
				$("nav").removeClass("mobile-open");
				resetMenuIcons();
				$(".toggle-menu--hamburger").removeClass("active");
				$("nav > div[id]").addClass("hidden");

				requestAnimationFrame(() => {
					const tgt = document.getElementById(hash.slice(1));
					if (tgt) {
						tgt.scrollIntoView({ behavior: "smooth", block: "start" });
					}
					history.replaceState(null, "", hash);
				});
			}
		});
	}

	initMenuBehavior();

	$(window).off("resize").on("resize", function () {
		initMenuBehavior();
		if (!$("nav").hasClass("mobile-open")) {
			resetMenuIcons();
		}
	});
});
